import { TYPOGRAPHY } from "@store/theme/design";
import { buttonBaseStyles, inputStyles } from "@store/theme/mixins";
import { polyfillCss } from "@store/theme/polyfills";

export default {
    defaultProps: {
        buttonProps: {
            css: polyfillCss`
                ${buttonBaseStyles("solid")}
                margin-top: 1.7em;
            `,
            typographyProps: {
                weight: TYPOGRAPHY.weight.black,
                size: TYPOGRAPHY.size.smaller,
                lineHeight: 1,
            },
        },
        cssOverrides: {
            inputSelect: inputStyles(),
        },
    },
};
